enum EStrapiNetwork {
	sepolia = 'sepolia',
	starknetSepolia = 'starknet-sepolia'
}

enum EWalletType {
	ethereum = 'ethereum',
	starknet = 'starknet'
}

enum EWalletId {
	blocknative = 'blocknative',
	argentX = 'argentX',
	braavos = 'braavos'
}

enum EStarknetChainId {
	MAINNET = '0x534e5f4d41494e',
	TESTNET = '0x534e5f5345504f4c4941'
}

export { EStarknetChainId, EStrapiNetwork, EWalletId, EWalletType };
